import React from 'react';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import LoadingScreen from 'src/components/LoadingScreen';

AuthProtectPurchaseOrderBuyerOrClosedOffersBuyerView.propTypes = {
  children: PropTypes.node
};

const homeUrl = process.env.REACT_APP_DOMAIN;

/**
 * THIS IS FOR STANDALONE PURCHASE ORDER
 * SINCE USER FROM CLOSED OFFER / CLOSED OFFER MANAGER MODULE CAN ACCESS IT
 * BUT THEY MIGHT NOT HAVE PURCHASE ORDER BUYER MODULE
 * SO THIS ACCESS ACCEPTS OR
 */
const allowedAccesses = [
  'purchaseOrderBuyerView',
  'closedOffersBuyerView',
  'closedOffersBuyerManagerView'
];

function AuthProtectPurchaseOrderBuyerOrClosedOffersBuyerView({ children }) {
  const { isLoading, isAuthenticated, user } = useAuth();
  const subAccessList = user?.access_list || [];
  const hasAccess = subAccessList.some((access) =>
    allowedAccesses.includes(access)
  );

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated || !hasAccess) {
    window.location = `${homeUrl}/unauthorized`;
    return <LoadingScreen />;
  }

  return <>{children}</>;
}

export default AuthProtectPurchaseOrderBuyerOrClosedOffersBuyerView;
